import { render, staticRenderFns } from "./scope23.vue?vue&type=template&id=46aa7ac0&scoped=true"
import script from "./scope23.vue?vue&type=script&lang=js"
export * from "./scope23.vue?vue&type=script&lang=js"
import style0 from "./scope23.vue?vue&type=style&index=0&id=46aa7ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa7ac0",
  null
  
)

export default component.exports